const cartTypes = {
  UPDATE_CART_ITEMS: "UPDATE_CART_ITEMS",
  TOGGLE_CART_OPEN: "TOGGLE_CART_OPEN",
};

export default cartTypes;
